<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center flex-wrap">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="34">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-3"
                      style="font-weight: 600;">
                      Data Summary Anggaran
                    </span>
                  </div>

                  <v-spacer />

                  <v-btn
                    color="#1976D2"
                    elevation="1"
                    class="text-capitalize font-weight-bold px-4 white--text rounded-lg"
                    @click="openGenerateDialog()">
                    <v-icon small class="mr-1">mdi-auto-fix</v-icon>
                    Generate Data
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="start"
            class="px-4 pb-2 pr-1">

            <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-start">
              <div class="filter-year-wrap">
                <div class="filter-year-label">
                  Tahun Anggaran
                </div>
                <v-select
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Pilih tahun"

                  :items="years"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="filter.year"
                  style="border-radius: 10px;"
                  hide-details>
                </v-select>
              </div>
            </v-col>
            <!-- <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-start">
              <v-btn
                color="#1976D2"
                rounded
                elevation="1"
                class="text-capitalize font-weight-bold px-4 white--text"
                @click="openGenerateDialog()">
                <v-icon small class="mr-1">mdi-auto-fix</v-icon>
                Generate Data
              </v-btn>
            </v-col> -->
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <div class="view" v-if="!process.load">
                  <div class="wrapper">
                    <table style="border: 1px solid #ededed;" class="table">
                      <tr>
                        <th rowspan="2" class="sticky-col one-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 150px; width: 150px; max-width: 150px;">Bulan</th>
                        <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran Murni</th>
                        <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran P1</th>
                        <th rowspan="2" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: right;">Anggaran Perubahan</th>
                        <th colspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: center;">Perkembangan Fisik</th>
                        <th colspan="4" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px; text-align: center;">Perkembangan Keuangan</th>
                      </tr>

                      <tr>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Realisasi %</th>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Target %</th>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 100px;">Deviasi %</th>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 240px; text-align: right;">Anggaran Kas Perbulan ( Rp )</th>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 300px;">Persentase SP2D terhadap Pagu Anggaran</th>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 220px; text-align: right;">Realisasi Keuangan/SP2D (Rp)</th>
                        <th style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 300px;">Persentase SP2D terhadap Kas Perbulan</th>
                      </tr>



                      <tr v-for="(item, index) in monthlyList" :key="index">
                        <td class="sticky-col one-col table-cell">
                          <div>
                            {{ getMonthLabel(item.bulan_anggaran) }}
                          </div>
                        </td>
                        <td class="table-cell text-right">
                          {{ item.is_exists ? formatCurrencyValue(item.anggaran_murni) : '-' }}
                        </td>
                        <td class="table-cell text-right">
                          {{ item.is_exists ? formatCurrencyValue(item.anggaran_p1) : '-' }}
                        </td>
                        <td class="table-cell text-right">
                          {{ item.is_exists ? formatCurrencyValue(item.anggaran_perubahan) : '-' }}
                        </td>
                        <td class="table-cell text-center">
                          {{ item.is_exists ? parseLocaleNumber(item.realisasi_fisik) : '-' }}
                        </td>
                        <td class="table-cell text-center">
                          {{ item.is_exists ? parseLocaleNumber(item.target_fisik) : '-' }}
                        </td>
                        
                        <td
                          class="table-cell text-center"
                          :style="{ background: item.is_exists ? getDeviasiColor(item.deviasi_fisik) : '' }">
                          {{ item.is_exists ? parseLocaleNumber(item.deviasi_fisik) : '-' }}
                        </td>
                        <td class="table-cell text-right">
                          {{ item.is_exists ? formatCurrencyValue(item.kas_per_bulan) : '-' }}
                        </td>
                        <td class="table-cell text-center">
                          {{ item.is_exists ? parseLocaleNumber(item.persentase_sp2d_pagu) : '-' }}
                        </td>
                        <td class="table-cell text-right">
                          {{ item.is_exists ? formatCurrencyValue(item.realisasi_keuangan_sp2d) : '-' }}
                        </td>
                        <td class="table-cell text-center">
                          {{ item.is_exists ? parseLocaleNumber(item.persentase_sp2d_kas_bulanan) : '-' }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>

        <v-dialog
          v-model="dialog.generate"
          width="700"
          persistent
          scrollable>
          <v-card>
            <v-card-title class="d-flex align-center">
              Generate Data Summary Anggaran
              <v-spacer />
              <v-btn icon color="red" @click="closeGenerateDialog()">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider />

            <v-card-text class="pt-4">
              <v-progress-linear
                v-if="process.generateLoad"
                indeterminate
                rounded
                :color="set_color"
                class="mb-4" />

              <v-row>
                <v-col cols="12" md="6">
                  <div class="body-2 mb-2">Tahun Anggaran</div>
                  <v-select
                    filled
                    rounded
                    dense
                    :color="set_color"
                    :items="years"
                    item-text="text"
                    item-value="value"
                    v-model="generateForm.tahun_anggaran"
                    style="border-radius: 10px;" />
                </v-col>

                <v-col cols="12" md="6">
                  <div class="body-2 mb-2">Bulan Anggaran</div>
                  <v-select
                    filled
                    rounded
                    dense
                    :color="set_color"
                    :items="months"
                    item-text="text"
                    item-value="value"
                    v-model="generateForm.bulan_anggaran"
                    style="border-radius: 10px;" />
                </v-col>
              </v-row>

              <v-row v-if="process.generateLoad">
                <v-col
                  cols="12"
                  md="12"
                  class="d-flex flex-column align-center justify-center"
                  style="height: 200px;">
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>


                  <div class="body-2 mt-4 ml-4">
                    Mohon Tunggu . . .
                  </div>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col
                  cols="12"
                  md="6"
                  v-for="(label, key) in generateInfoFields"
                  :key="key">
                  <div class="body-2 mb-1">{{ label }}</div>
                  <v-text-field
                    dense
                    outlined
                    readonly
                    hide-details
                    :value="formatGenerateValue(key)"
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn
                outlined
                color="red"
                class="text-capitalize rounded-lg"
                @click="closeGenerateDialog()">
                Batal
              </v-btn>
              <v-btn
                color="green"
                :disabled="process.generateLoad || process.generateSave"
                class="text-capitalize white--text rounded-lg"
                :loading="process.generateSave"
                @click="saveGenerate()">
                Simpan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>



<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,
          generate: false
        },
        detail: {},

        type: ['Asisten', 'Sekda', 'Dinas Pendidikan', 'Kecamatan', 'Dinas Kesehatan', 'Semua Kecamatan', 'Semua Kelurahan', 'Semua Puskesmas'],

        category: ['OPD', 'Gabungan'],

        asistensi: ['Asisten Administrasi Umum', 'Asisten Perekonomian dan Pembangunan', 'Asisten Pemerintahan dan Kesejahteraan Rakyat'],
        
        search: '',

        filter: {
          year: new Date().getFullYear(),

          month: 1,
          month_text: 'Januari',

          unit_id: '',
          unit_title: '',
          asistensi: '',
          kecamatan_id: '',
          kecamatan_title: '',
          type: '',
          category: '',
          is_pengecualian: '1',
          dpa: 'murni'
        },

        filter_data: {
          unit: [],
          kecamatan: [
            {
              name: 'KECAMATAN KLATEN TENGAH',
              id: '42,326,327,328,330,329,325'
            },
            {
              name: 'KECAMATAN KLATEN UTARA',
              id: '43,334,335'
            },
            {
              name: 'KECAMATAN KLATEN SELATAN',
              id: '41,313'
            },
            {
              name: 'KECAMATAN JATINOM',
              id: '32,179'
            }
          ]
        },

        listMurni: [],
        detailMurni: {},
        dpaData: {},
        generateForm: {
          tahun_anggaran: new Date().getFullYear(),
          bulan_anggaran: new Date().getMonth() + 1,
          anggaran_murni: 0,
          anggaran_p1: 0,
          anggaran_perubahan: 0,
          target_fisik: 0,
          realisasi_fisik: 0,
          deviasi_fisik: 0,
          kas_per_bulan: 0,
          persentase_sp2d_pagu: 0,
          realisasi_keuangan_sp2d: 0,
          persentase_sp2d_kas_bulanan: 0
        },
        generateInfoFields: {
          anggaran_murni: 'Anggaran Murni',
          anggaran_p1: 'Anggaran P1',
          anggaran_perubahan: 'Anggaran Perubahan',
          target_fisik: 'Target Fisik',
          realisasi_fisik: 'Realisasi Fisik',
          deviasi_fisik: 'Deviasi Fisik',
          kas_per_bulan: 'Kas Per Bulan',
          persentase_sp2d_pagu: 'Persentase SP2D terhadap Pagu',
          realisasi_keuangan_sp2d: 'Realisasi Keuangan SP2D',
          persentase_sp2d_kas_bulanan: 'Persentase SP2D terhadap Kas Bulanan'
        },

        selected: {
          row: [],
          freeze: [],
          delete: []
        },

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        process: {
          load: false,

          export: false,
          exportExcel: false,
          generateLoad: false,
          generateSave: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },

      'filter.year': function () {
        this.fetch()
      },
      'generateForm.tahun_anggaran': function () {
        this.fetchGenerateData()
      },
      'generateForm.bulan_anggaran': function () {
        this.fetchGenerateData()
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      dpa () {
        return this.$store.state.dpa
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        
        // this.filter.month = numb

        // this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },
      summaryTotals () {
        const totals = {
          anggaran_murni: 0,
          anggaran_p1: 0,
          anggaran_perubahan: 0,
          target_fisik: 0,
          realisasi_fisik: 0,
          deviasi_fisik: 0,
          kas_per_bulan: 0,
          persentase_sp2d_pagu: 0,
          realisasi_keuangan_sp2d: 0,
          persentase_sp2d_kas_bulanan: 0
        }

        this.list.forEach(item => {
          totals.anggaran_murni += this.parseLocaleNumber(item.anggaran_murni)
          totals.anggaran_p1 += this.parseLocaleNumber(item.anggaran_p1)
          totals.anggaran_perubahan += this.parseLocaleNumber(item.anggaran_perubahan)
          totals.target_fisik += this.parseLocaleNumber(item.target_fisik)
          totals.realisasi_fisik += this.parseLocaleNumber(item.realisasi_fisik)
          totals.deviasi_fisik += this.parseLocaleNumber(item.deviasi_fisik)
          totals.kas_per_bulan += this.parseLocaleNumber(item.kas_per_bulan)
          totals.persentase_sp2d_pagu += this.parseLocaleNumber(item.persentase_sp2d_pagu)
          totals.realisasi_keuangan_sp2d += this.parseLocaleNumber(item.realisasi_keuangan_sp2d)
          totals.persentase_sp2d_kas_bulanan += this.parseLocaleNumber(item.persentase_sp2d_kas_bulanan)
        })

        return totals
      },
      monthlyList () {
        return this.months.map(month => {
          const matched = this.list.find(item => String(item.bulan_anggaran) === String(month.value))
          if (matched) {
            return {
              ...matched,
              is_exists: true
            }
          }

          return {
            bulan_anggaran: month.value,
            is_exists: false
          }
        })
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      parseLocaleNumber (value) {
        if (value === null || value === undefined || value === '') return 0
        if (typeof value === 'number') return value

        let normalized = String(value).trim()
        normalized = normalized.replace(/[^0-9,.-]/g, '')

        // Indonesian decimal format: 1.234,56 -> 1234.56
        if (normalized.includes(',')) {
          normalized = normalized.replace(/\./g, '').replace(',', '.')
        }

        const parsed = Number(normalized)
        return isNaN(parsed) ? 0 : parsed
      },
      getMonthLabel (monthValue) {
        const selected = this.months.find(m => String(m.value) === String(monthValue))
        return selected ? selected.text : monthValue
      },
      getDeviasiColor (value) {
        const deviasi = this.parseLocaleNumber(value)

        if (deviasi <= -10) return 'red'
        if (deviasi > 10) return 'blue'
        if (deviasi >= -2.99 && deviasi <= 9.99) return 'green'
        if (deviasi >= -5.99 && deviasi <= -3) return 'yellow'
        if (deviasi >= -9.99 && deviasi <= -6) return 'orange'

        return ''
      },
      getGenerateDpaStatus () {
        if (!this.dpaData || !this.dpaData.tahun) {
          return 'perubahan'
        }

        const selectedDate = new Date(this.generateForm.tahun_anggaran, this.generateForm.bulan_anggaran - 1, 1)
        const p1Date = this.dpaData.p1_date ? new Date(this.dpaData.p1_date) : null
        const perubahanDate = this.dpaData.perubahan_date ? new Date(this.dpaData.perubahan_date) : null
        const murniDate = this.dpaData.murni_date ? new Date(this.dpaData.murni_date) : null

        const selectedMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1)
        const murniMonth = murniDate ? new Date(murniDate.getFullYear(), murniDate.getMonth(), 1) : null
        const p1Month = p1Date ? new Date(p1Date.getFullYear(), p1Date.getMonth(), 1) : null
        const perubahanMonth = perubahanDate ? new Date(perubahanDate.getFullYear(), perubahanDate.getMonth(), 1) : null

        if (perubahanMonth && selectedMonth >= perubahanMonth) return 'perubahan'
        if (p1Month && selectedMonth >= p1Month && (!perubahanMonth || selectedMonth < perubahanMonth)) return 'p1'
        if (murniMonth && selectedMonth >= murniMonth && (!p1Month || selectedMonth < p1Month)) return 'murni'

        return 'perubahan'
      },
      formatGenerateValue (key) {
        const numericValue = this.parseLocaleNumber(this.generateForm[key])

        return new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(numericValue)
      },
      formatCurrencyValue (value) {
        const numericValue = this.parseLocaleNumber(value)

        return new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(numericValue)
      },
      openGenerateDialog () {
        this.generateForm.tahun_anggaran = this.filter.year || new Date().getFullYear()
        this.generateForm.bulan_anggaran = this.filter.month || (new Date().getMonth() + 1)
        this.dialog.generate = true
        this.fetchGenerateData()
      },
      closeGenerateDialog () {
        this.dialog.generate = false
      },
      resetGenerateNumbers () {
        this.generateForm.anggaran_murni = 0
        this.generateForm.anggaran_p1 = 0
        this.generateForm.anggaran_perubahan = 0
        this.generateForm.target_fisik = 0
        this.generateForm.realisasi_fisik = 0
        this.generateForm.deviasi_fisik = 0
        this.generateForm.kas_per_bulan = 0
        this.generateForm.persentase_sp2d_pagu = 0
        this.generateForm.realisasi_keuangan_sp2d = 0
        this.generateForm.persentase_sp2d_kas_bulanan = 0
      },
      async fetchGenerateData () {
        if (!this.dialog.generate) return
        if (!this.generateForm.tahun_anggaran || !this.generateForm.bulan_anggaran) return

        this.process.generateLoad = true
        this.resetGenerateNumbers()

        try {
          const dpaResponse = await get('admin/dpa/data', {
            params: { tahun: this.generateForm.tahun_anggaran }
          })
          if (dpaResponse.data.status === 200 && dpaResponse.data.results.data.length > 0) {
            this.dpaData = dpaResponse.data.results.data[0]
          } else {
            this.dpaData = {}
          }

          const commonParams = {
            limit: 2000000000000000,
            page: 1,
            search: '',
            unit_id: '',
            unit_asisten: '',
            gabungan: '',
            gabungan_id: '',
            tahun_anggaran: this.generateForm.tahun_anggaran,
            is_pengecualian: '1',
            year: this.generateForm.tahun_anggaran,
            month: this.generateForm.bulan_anggaran
          }

          const responseMurni = await get('admin/report/summary_opd', {
            params: {
              ...commonParams,
              dpa_status: 'murni'
            }
          })
          const responseCurrent = await get('admin/report/summary_opd', {
            params: {
              ...commonParams,
              dpa_status: this.getGenerateDpaStatus()
            }
          })

          const murniResult = responseMurni.data?.results || {}
          const currentResult = responseCurrent.data?.results || {}

          this.generateForm.anggaran_murni = this.parseLocaleNumber(murniResult.grand_total_anggaran)
          this.generateForm.anggaran_p1 = this.parseLocaleNumber(currentResult.grand_total_anggaran_p1)
          this.generateForm.anggaran_perubahan = this.parseLocaleNumber(currentResult.grand_total_anggaran_perubahan)
          this.generateForm.target_fisik = this.parseLocaleNumber(currentResult.grand_total_total_target_fisik)
          this.generateForm.realisasi_fisik = this.parseLocaleNumber(currentResult.grand_total_realisasi_fisik)
          this.generateForm.deviasi_fisik = this.parseLocaleNumber(currentResult.grand_total_deviasi)
          this.generateForm.kas_per_bulan = this.parseLocaleNumber(currentResult.grand_total_target_keuangan)
          this.generateForm.persentase_sp2d_pagu = this.parseLocaleNumber(currentResult.grand_total_persentase_sp2d)
          this.generateForm.realisasi_keuangan_sp2d = this.parseLocaleNumber(currentResult.total_realisasi_keuangan)
          this.generateForm.persentase_sp2d_kas_bulanan = this.parseLocaleNumber(currentResult.grand_total_persentase_sp2d_anggaran)
        } finally {
          this.process.generateLoad = false
        }
      },
      async saveGenerate () {
        this.message.error = ''
        this.process.generateSave = true

        try {
          const response = await post('admin/summary/add_update', {
            data: {
              tahun_anggaran: this.generateForm.tahun_anggaran,
              bulan_anggaran: this.generateForm.bulan_anggaran,
              anggaran_murni: this.generateForm.anggaran_murni,
              anggaran_p1: this.generateForm.anggaran_p1,
              anggaran_perubahan: this.generateForm.anggaran_perubahan,
              target_fisik: this.generateForm.target_fisik,
              realisasi_fisik: this.generateForm.realisasi_fisik,
              deviasi_fisik: this.generateForm.deviasi_fisik,
              kas_per_bulan: this.generateForm.kas_per_bulan,
              persentase_sp2d_pagu: this.generateForm.persentase_sp2d_pagu,
              realisasi_keuangan_sp2d: this.generateForm.realisasi_keuangan_sp2d,
              persentase_sp2d_kas_bulanan: this.generateForm.persentase_sp2d_kas_bulanan
            }
          })
          const res = response.data

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Data summary berhasil disimpan'
            this.closeGenerateDialog()
            this.fetch()
          } else {
            this.message.error = res.message
          }
        } finally {
          this.process.generateSave = false
        }
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = Number(value)
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'month_year') {
          data = value.length > 0 ? moment(value).format('MMM, YYYY') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 2000000000000000, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,

          tahun_anggaran: this.filter.year
        }

        this.selected.row = []

        await get(`admin/summary/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Unit',
                width: '400px',
                value: 'unit_name',
                freeze: true,
                hide: false
              },
              {
                text: 'Asisten',
                width: '400px',
                value: 'unit_asisten',
                freeze: false,
                hide: false
              },
              {
                text: 'Nominal Anggaran',
                width: '200px',
                value: 'total_anggaran',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Nominal Anggaran Perubahan',
                width: '300px',
                value: 'total_anggaran_perubahan',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Tahun Anggaran',
                width: '200px',
                value: 'tahun_anggaran',
                freeze: false,
                hide: false,
                align: 'center'
              },
              {
                text: 'Target Fisik',
                width: '200px',
                value: 'total_target_fisik',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Target Keuangan',
                width: '200px',
                value: 'total_target_keu',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Realisasi Fisik',
                width: '200px',
                value: 'total_realisasi_fisik',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Realisasi Keuangan',
                width: '200px',
                value: 'total_realisasi_keu',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Deviasi',
                width: '200px',
                value: 'deviasi',
                freeze: false,
                hide: false,
                align: 'center'
              },
              {
                text: 'SP2D (%)',
                width: '200px',
                value: 'persentase_sp2d',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'SP2D (Anggaran)',
                width: '200px',
                value: 'persentase_sp2d_anggaran',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              }
            ]

            this.list = res.results.data
            this.detail = res.results
            this.pagination = {
              total_data: res.results.data.length,
              total_page: 1,
              total_display: res.results.data.length,
              first_page: false,
              last_page: false,
              prev: 0,
              current: 1,
              next: 0,
              detail: [],
              start: 1,
              end: 10
            }

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
    }
  }
</script>


<style>
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    width: 100%;
  }

  .filter-year-wrap {
    width: 100%;
    /* max-width: 260px; */
  }

  .filter-year-label {
    font-size: 12px;
    font-weight: 600;
    color: #6b6b6b;
    margin-bottom: 6px;
  }

  .table-cell {
    font-size: 12px;
    border: 1px solid #ededed;
    padding: 8px 12px;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .wrapper { 
    overflow-y: auto; 
    max-height: 70vh; 
  } 
  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 

  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }
</style>